import React, { Component, forwardRef } from "react";
import Modal from "react-responsive-modal";
import { withNamespaces } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmAlert } from "react-confirm-alert"; // Import
import { InputText } from "primereact/inputtext";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import varAxios from "../../Comman/axios";
import SnackbarProgress from "./SnackbarProgress";
import {
  GenerateMonthlyReport,
  GenerateMonthlyReportExcel,
} from "../../Comman/apiEndPoints";

class MonthlyReportComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedRows: null,
      openModalUser: false,
      openModalAlarm: false,
      RegionId: "",
      IsAllRegion: false,
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endDate: new Date(),
      Type: "",
      includeDetails: false,
      downloadProgress:0,
      snackbarOpen: false
    };

    this.openModalUser = this.openModalUser.bind(this);
    this.closeModalUser = this.closeModalUser.bind(this);
    this.openModalAlarm = this.openModalAlarm.bind(this);
    this.closeModalAlarm = this.closeModalAlarm.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.commonFuncMonthlyReport = this.commonFuncMonthlyReport.bind(this);
    this.PushNotification = this.PushNotification.bind(this);
  }

  handleInput = (e) => {
    let value = e.target.value;
    let payload = {
      RegionId: value,
      FromDate: new Date(this.state.startDate.getTime() + 86400000)
        .toISOString()
        .split("T")[0],
      ToDate: this.state.endDate.toISOString().split("T")[0],
      IsAllRegion: value == 0 ? true : false,
    };
    this.state.RegionId = value.toString();

    this.commonFuncMonthlyReport(payload);
    this.setState({ RegionId: value.toString() });
    // sleep(3000).then(() => {
    //     console.log("setstate",this.state);
    // })
  };
  commonFuncMonthlyReport(data) {
    this.props.getMonthlyReportList(data);
  }
  patientFullname(data) {
    return data.FirstName + " " + data.LastName;
  }
  openModalUser(type) {
    this.setState({ Type: type });
    let payload = {
      RegionId: this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId,
      IsAllRegion:
        this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId == 0
          ? true
          : false,
      Type: type,
      FromDate: new Date(this.state.startDate.getTime() + 86400000)
        .toISOString()
        .split("T")[0],
      ToDate: this.state.endDate.toISOString().split("T")[0],
    };
    this.props.getUserList(payload);
    setTimeout(() => {
      this.setState({ openModalUser: true });
    }, 700);
  }

  closeModalUser() {
    this.setState({ globalFilterUser: "" });
    this.setState({ openModalUser: false });
  }
  openModalAlarm(type) {
    let payload = {
      RegionId: this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId,
      IsAllRegion:
        this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId == 0
          ? true
          : false,
      Type: type,
      FromDate: new Date(this.state.startDate.getTime() + 86400000)
        .toISOString()
        .split("T")[0],
      ToDate: this.state.endDate.toISOString().split("T")[0],
      //FromDate: this.state.startDate.toISOString().split('T')[0],
      //ToDate: this.state.endDate.toISOString().split('T')[0]
    };
    this.props.getAlarmList(payload);
    setTimeout(() => {
      this.setState({ openModalAlarm: true });
    }, 700);
  }
  closeModalAlarm() {
    this.setState({ globalFilterAlarm: "" });
    this.setState({ openModalAlarm: false });
  }
  formatUserPos1(rowData) {
    if (rowData.PosLat && rowData.PosLon) {
      return (
        <p>
          {rowData.PosLat}, {rowData.PosLon}
        </p>
      );
    } else {
      return;
    }
  }

  formatRegionDate(rowData) {
    if (rowData.CreatedDate != null && rowData.CreatedDate != undefined) {
      if (rowData.CreatedDate == "0001-01-01T00:00:00") {
        return;
      } else {
        let value = rowData.CreatedDate.split("T");
        let data = value[1].split(":");
        let sec = data[2].split(".");
        return <p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>;
      }
    }
  }
  formatAlarmStatusDate(rowData) {
    if (
      rowData.StatusUpdatedDate != null &&
      rowData.StatusUpdatedDate != undefined
    ) {
      if (rowData.StatusUpdatedDate == "0001-01-01T00:00:00") {
        return;
      } else {
        let value = rowData.StatusUpdatedDate.split("T");
        let data = value[1].split(":");
        let sec = data[2].split(".");
        return <p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>;
      }
    }
  }
  formatAlarmCount(rowData) {
    debugger;
    if (rowData.items.length != 0) {
      return <p>{rowData.items.length}</p>;
    } else {
      return <p>0</p>;
    }
  }
  formatAlarmStatusDate1(rowData) {
    if (
      rowData.IsLifeguardPerformedCPR != null &&
      rowData.IsLifeguardPerformedCPR != undefined &&
      rowData.IsLifeguardPerformedCPR == false
    ) {
      return <p>NO</p>;
    }
    if (rowData.IsLifeguardPerformedCPR == true) {
      return <p>Yes</p>;
    }
  }
  formatAlarmCreatedDate(rowData) {
    if (
      rowData.AlarmCreatedDate != null &&
      rowData.AlarmCreatedDate != undefined
    ) {
      if (rowData.AlarmCreatedDate == "0001-01-01T00:00:00") {
        return;
      } else {
        let value = rowData.AlarmCreatedDate.split("T");
        let data = value[1].split(":");
        let sec = data[2].split(".");
        return <p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>;
      }
    }
  }
  handleChange = ({ startDate, endDate }) => {
    startDate = startDate || this.state.startDate;
    endDate = endDate || this.state.endDate;
    let start = new Date(startDate.getTime() + 86400000)
      .toISOString()
      .split("T");
    let end = endDate.toISOString().split("T");
    /* if (startDate.isAfter(endDate)) {
          endDate = startDate;
        } */
    if (endDate.getTime() <= startDate.getTime()) {
      alert("The Date must be smaller or Equal to today date");
      return;
    }
    let payload = {
      RegionId:
        this.state.RegionId == ""
          ? this.props.MonthlyReportDetails.regionList.length > 0
            ? this.props.MonthlyReportDetails.regionList[0].ID
            : null
          : this.state.RegionId,
      FromDate: start[0],
      ToDate: end[0],
      IsAllRegion:
        this.state.RegionId == undefined ||
        this.state.RegionId == 0 ||
        this.state.RegionId == "0" ||
        this.state.RegionId == null
          ? true
          : false,
    };
    this.commonFuncMonthlyReport(payload);
    this.setState({ startDate, endDate }, () => {
      this.datepicker.input.focus();
    });
  };
 handleDocType = (data) => {
   debugger
    let payload = {
      RegionId:
        this.state.RegionId == ""
          ? this.props.MonthlyReportDetails.regionList.length > 0
            ? this.props.MonthlyReportDetails.regionList[0].ID
            : null
          : this.state.RegionId,
        IsExcelReport:data
    };
     this.props.UpdateReportTypeSetting(payload)
  };
  handleChangeStart = (startDate) => this.handleChange({ startDate });

  handleChangeEnd = (endDate) => this.handleChange({ endDate });

  PushNotification() {
    const { t } = this.props;

    confirmAlert({
      title: "Confirm to Mail PDF",
      message: `Are you sure you want to mail monthly report?`,
      buttons: [
        {
          label: `${t("First_Responder.Yes")}`,
          onClick: () => {
            this.state.RegionId =
              this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId;
            this.setState({
              RegionId: this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId,
            });
            let payload = {
              RegionId: this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId,
              IsAllRegion:
                this.state.RegionId == undefined ||
                this.state.RegionId == "" ||
                this.state.RegionId == 0 ||
                this.state.RegionId == "0" ||
                this.state.RegionId == null
                  ? true
                  : false,
              FromDate: new Date(this.state.startDate.getTime() + 86400000)
                .toISOString()
                .split("T")[0],
              ToDate: this.state.endDate.toISOString().split("T")[0],
            };
            this.props.PerRegionPdfEmail(payload);
          },
        },
        {
          label: `${t("First_Responder.No")}`,
          onClick: () => {},
        },
      ],
    });
  }
  rowExpansionTemplate = (data) => {
    const { t } = this.props;
    return (
      <div className="orders-subtable">
        <div className="child-table-container">
          <DataTable
            value={data.items}
            responsiveLayout="scroll"
            emptyMessage={t("Feedback Setting.No records found")}
          >
            {/* <Column field="Image" header="Profile" body={this.showImage} sortable={true} /> */}
            <Column
              field="RegionName"
              header={t("Monthly Report.Region")}
              sortable={true}
              className="wordBreakLine"
            />

            <Column
              field="MissionId"
              header={t("Monthly Report.Mission ID")}
              sortable={true}
              className="wordBreakLine"
            />
            <Column
              field="AlarmCreatedDate"
              header={t("First_Responder.Created Date")}
              body={this.formatAlarmCreatedDate}
              sortable={true}
              className="wordBreakLine"
            />

            <Column
              field="AlarmCategory"
              header={t("Notification Setting.Category")}
              sortable={true}
              className="wordBreakLine"
            />
            <Column
              field="Status"
              header={"Status"}
              sortable={true}
              className="wordBreakLine"
            />
            <Column
              field="StatusUpdatedDate"
              header="Updated Date"
              body={this.formatAlarmStatusDate}
              sortable={true}
              className="wordBreakLine"
            />

            <Column
              field="PosLat"
              header={"Lat"}
              sortable={true}
              className="wordBreakLine"
            />
            <Column
              field="PosLon"
              header={"Lon"}
              sortable={true}
              className="wordBreakLine"
            />
          </DataTable>
        </div>
      </div>
    );
  };
  render() {
    const { t } = this.props;

    let regionListOption;
    let regionList = this.props.MonthlyReportDetails.regionList;

    var monthlyReportData = this.props.MonthlyReportDetails.lifeGuardAlarm;
    if (regionList) {
      regionListOption = regionList.map((item) => (
        <option value={item.ID} key={item.ID}>
          {item.RegionName}
        </option>
      ));
    }
    let transformedArray;
    let transformedArray1;
    if (this.props.MonthlyReportDetails.alarmList) {
      transformedArray1 = Object.values(
        this.props.MonthlyReportDetails.alarmList.reduce(
          (accumulator, currentObject) => {
            let dateObject = moment(currentObject.AlarmCreatedDate);
            let formattedDate = dateObject.format("YYYY-MM-DD");
            const date = formattedDate;
            if (!accumulator[date]) {
              accumulator[date] = {
                AlarmCreatedDate: formattedDate,
                items: [],
              };
            }
            accumulator[date].items.push(currentObject);
            return accumulator;
          },
          {},
        ),
      );
      transformedArray = [...transformedArray1].sort((a, b) => {
        const dateA = new Date(a.AlarmCreatedDate);
        const dateB = new Date(b.AlarmCreatedDate);
        return dateB - dateA;
      });
      console.log("jk", transformedArray);
    }
    //this.state.RegionId=this.props.MonthlyReportDetails.regionList.length >0 ?this.props.MonthlyReportDetails.regionList[0].ID:null
    this.setState();
    const FromCustomInput = forwardRef(({ value, onClick, className }, ref) => (
      <span>
        <label>{t("Monthly Report.From")}:</label>
        <button
          className="btn btn-primary"
          onClick={onClick}
          ref={ref}
          style={{ marginRight: "9px", marginLeft: "4px" }}
        >
          {value} <i class="fa fa-calendar" aria-hidden="true"></i>
        </button>
      </span>
    ));
    const ToCustomInput = forwardRef(({ value, onClick, className }, ref) => (
      <span>
        <label>{t("Monthly Report.To")}:</label>
        <button
          className="btn btn-primary"
          onClick={onClick}
          ref={ref}
          style={{ marginLeft: "4px" }}
        >
          {value} <i class="fa fa-calendar" aria-hidden="true"></i>
        </button>
      </span>
    ));
    var headerUser = (
      <div className="search-name" style={{ width: "20vh" }}>
        <InputText
          style={{ width: "20vh" }}
          type="text"
          onInput={(e) => this.setState({ globalFilterUser: e.target.value })}
          placeholder={t("First_Responder.Search")}
          size="50"
        />
      </div>
    );
    var headerAlarm = (
      <div className="search-name" style={{ width: "20vh" }}>
        <InputText
          style={{ width: "20vh" }}
          type="text"
          onInput={(e) => this.setState({ globalFilterAlarm: e.target.value })}
          placeholder={t("First_Responder.Search")}
          size="50"
        />
      </div>
    );

  
const downloadPdf = async () => {
  try {
    this.setState({ snackbarOpen: true, downloadProgress: 0 });
let payload = {
          RegionId:
            this.state.RegionId == ""
              ? this.props.MonthlyReportDetails.regionList.length > 0
                ? this.props.MonthlyReportDetails.regionList[0].ID
                : null
              : this.state.RegionId,
          IsAllRegion:
            this.state.RegionId == undefined ||
            this.state.RegionId == 0 ||
            this.state.RegionId == "0" ||
            this.state.RegionId == null
              ? true
              : false,
          //FromDate: dtfUK.format(new Date(this.state.startDate)).replace(/,/g, ''),
          //ToDate: dtfUK.format(new Date(this.state.endDate)).replace(/,/g, '')
          FromDate: new Date(this.state.startDate.getTime() + 86400000)
            .toISOString()
            .split("T")[0],
          ToDate: this.state.endDate.toISOString().split("T")[0],
        }
    const response = await varAxios.post(GenerateMonthlyReport, payload, {
      responseType: "blob",
      onDownloadProgress: (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded * 100) / event.total);
          this.setState({ downloadProgress: percent });
        }
      },
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "monthlyReport.pdf";
    link.click();

    URL.revokeObjectURL(url);

    setTimeout(() => {
      this.setState({ snackbarOpen: false });
    }, 1000);
  } catch (err) {
    console.error(err);
    this.setState({ snackbarOpen: false });
  }
};

    const downloadExcel = async () => {
      try {
         this.setState({ snackbarOpen: true, downloadProgress: 0 });
        const dtfUK = new Intl.DateTimeFormat("UK", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        this.state.RegionId =
          this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId;
        this.setState({
          RegionId: this.props.MonthlyReportDetails.lifeGuardAlarm.RegionId,
        });
        let payload = {
          RegionId:
            this.state.RegionId == ""
              ? this.props.MonthlyReportDetails.regionList.length > 0
                ? this.props.MonthlyReportDetails.regionList[0].ID
                : null
              : this.state.RegionId,
          IsAllRegion:
            this.state.RegionId == undefined ||
            this.state.RegionId == 0 ||
            this.state.RegionId == "0" ||
            this.state.RegionId == null
              ? true
              : false,
          //FromDate: dtfUK.format(new Date(this.state.startDate)).replace(/,/g, ''),
          //ToDate: dtfUK.format(new Date(this.state.endDate)).replace(/,/g, '')
          FromDate: new Date(this.state.startDate.getTime() + 86400000)
            .toISOString()
            .split("T")[0],
          ToDate: this.state.endDate.toISOString().split("T")[0],
        };
        const response = await varAxios.post(
          GenerateMonthlyReportExcel,
          payload, {
      responseType: "blob",
      onDownloadProgress: (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded * 100) / event.total);
          this.setState({ downloadProgress: percent });
        }
      },
    }
        );

        // Create a Blob from the response data
        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a temporary URL for the Blob
        const url = window.URL.createObjectURL(pdfBlob);

        // Create a temporary <a> element to trigger the download
        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute(
          "download",
          `monthlyReport_${this.state.RegionId == "" ? (this.props.MonthlyReportDetails.regionList.length > 0 ? this.props.MonthlyReportDetails.regionList[0].ID : null) : this.state.RegionId}_${payload.FromDate}_${payload.ToDate}.xlsx`,
        ); // Set the desired filename for the downloaded file

        // Append the <a> element to the body and click it to trigger the download
        document.body.appendChild(tempLink);
        tempLink.click();

        // Clean up the temporary elements and URL
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
        setTimeout(() => {
      this.setState({ snackbarOpen: false });
    }, 1000);
      }catch (err) {
    console.error(err);
    this.setState({ snackbarOpen: false });
  }
    };

    
    return (
      <div className="container carousel-page ">
        <div className="progressbar-heading grids-heading print">
          <h2>{t("Monthly Report.MonthlyReport")}</h2>
          <div className="text-left m-b-25 ">
            <select
              id="regionData"
              style={{ fontSize: "large", padding: "7px" }}
              onChange={this.handleInput}
              placeholder="Select"
              ref="regionData"
              name={"RegionId"}
              value={this.state.RegionId}
            >
              {regionListOption}
              <option
                style={{ background: "red", color: "white" }}
                value={0}
                key={0}
              >
                {t("Monthly Report.AllRegions")}
              </option>
            </select>
            <i
              class="fa fa-envelope"
              onClick={this.PushNotification}
              title={"Push Document to Users"}
              style={{
                cursor: "pointer",
                marginLeft: "5px",
                fontSize: "21px",
                color: "midnightblue",
              }}
            ></i>
          </div>
          <div className="text-right m-b-25 ">
            <DatePicker
              selected={this.state.startDate}
              selectsStart
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              customInput={<FromCustomInput className="example-custom-input" />}
              onChange={this.handleChangeStart}
            />
            <DatePicker
              selected={this.state.endDate}
              selectsEnd
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              customInput={<ToCustomInput className="example-custom-input" />}
              onChange={this.handleChangeEnd}
              ref={(datepicker) => {
                this.datepicker = datepicker;
              }}
            />

    
 
        
            <span onClick={downloadExcel}>
              <i
                className="fa fa fa-file-excel-o"
                title={"Download Excel"}
                style={{
                  cursor: "pointer",
                  marginLeft: "9px",
                  marginRight: "4px",
                  fontSize: "25px",
                  color: "midnightblue",
                }}
              ></i>
            </span>
            <span onClick={downloadPdf}>
              <i
                className="fa fa-file-pdf-o"
                title={"Download Pdf"}
                style={{
                  cursor: "pointer",
                  marginLeft: "5px",
                  fontSize: "25px",
                  color: "midnightblue",
                }}
              ></i>
            </span>
          </div>
        </div>
        <div className="overflow-scroll">
          <table id="table">
            <thead>
              <tr>
                <th>{t("Monthly Report.Description")}</th>
                <th>{t("Monthly Report.TotalCount")}</th>
                <th>{t("Carousel Setting.Action")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="handle width-13">
                  {t("Monthly Report.Registered lifeguards")}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.RegisteredLifeGuardCount
                    ? monthlyReportData.RegisteredLifeGuardCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(
                      this,
                      "RegisteredLifeGuard",
                    )}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  {t("Monthly Report.Recruited lifeguards")}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.RecruitedCount
                    ? monthlyReportData.RecruitedCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(this, "Recruited")}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  {t("Monthly Report.Alarms per day")}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.AlarmPerdayCount
                    ? monthlyReportData.AlarmPerdayCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalAlarm.bind(this, "AlarmPerday")}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  {t("Monthly Report.Lifeguards received the alarm")}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.ReceivedAlarmCount
                    ? monthlyReportData.ReceivedAlarmCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(this, "ReceivedAlarm")}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  {t("Monthly Report.Lifeguards accepted the Alarm")}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.AcceptAlarmCount
                    ? monthlyReportData.AcceptAlarmCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(this, "AcceptAlarm")}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  {t("Monthly Report.Lifeguards declined the Alarm")}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.DeclineAlarmCount
                    ? monthlyReportData.DeclineAlarmCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(this, "DeclineAlarm")}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  {t(
                    "Monthly Report.Total lifeguards on scene for the cardiac arrest",
                  )}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.LifeGuardOnSceneForCardiacArrestCount
                    ? monthlyReportData.LifeGuardOnSceneForCardiacArrestCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(
                      this,
                      "LifeGuardOnSceneForCardiacArrest",
                    )}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              {/*   <tr >
                                <td className="handle width-13">{t('Monthly Report.Total lifeguards on site before ambulance and IVPA')}</td>
                                <td className="handle width-20">{monthlyReportData.LifeGuardOnSiteBeforeAmbulanceCount ? monthlyReportData.LifeGuardOnSiteBeforeAmbulanceCount : 0}</td>
                                <td className="handle width-20">
                                    <button type="button" className="btn btn-primary edit-carousel"
                                        onClick={this.openModalUser.bind(this, 'LifeGuardOnSiteBeforeAmbulance')}>{t('Monthly Report.View')}</button>

                                </td>
                            </tr> */}
              <tr>
                <td className="handle width-13">
                  {t("Monthly Report.Total lifeguards performed CPR")}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.LifeGuardPerformedCPRCount
                    ? monthlyReportData.LifeGuardPerformedCPRCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(
                      this,
                      "LifeGuardPerformedCPR",
                    )}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  {t(
                    "Monthly Report.Total lifeguards who have connected defibrillators",
                  )}
                </td>
                <td className="handle width-20">
                  {monthlyReportData.LifeGuardConnectedDefibrillatorsCount
                    ? monthlyReportData.LifeGuardConnectedDefibrillatorsCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(
                      this,
                      "LifeGuardConnectedDefibrillators",
                    )}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
              <tr>
                <td className="handle width-13">
                  Total lifeguards who have used defibrillators
                </td>
                <td className="handle width-20">
                  {monthlyReportData.LifeGuardUseDefibrillatorsCount
                    ? monthlyReportData.LifeGuardUseDefibrillatorsCount
                    : 0}
                </td>
                <td className="handle width-20">
                  <button
                    type="button"
                    className="btn btn-primary edit-carousel"
                    onClick={this.openModalUser.bind(
                      this,
                      "LifeGuardUseDefibrillators",
                    )}
                  >
                    {t("Monthly Report.View")}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Modal
          open={this.state.openModalUser}
          onClose={this.closeModalUser}
          center
          classNames={{ modal: "UpdateMonthlyUserModal" }}
        >
          <div className="">
            <div className="progressbar-heading grids-heading">
              <div>
                {(() => {
                  if (this.state.Type === "RegisteredLifeGuard") {
                    return <h2>{t("Monthly Report.Registered lifeguards")}</h2>;
                  }
                  if (this.state.Type === "Recruited") {
                    return <h2>{t("Monthly Report.Recruited lifeguards")}</h2>;
                  }
                  if (this.state.Type === "ReceivedAlarm") {
                    return (
                      <h2>
                        {t("Monthly Report.Lifeguards received the alarm")}
                      </h2>
                    );
                  }
                  if (this.state.Type === "AcceptAlarm") {
                    return (
                      <h2>
                        {t("Monthly Report.Lifeguards accepted the Alarm")}
                      </h2>
                    );
                  }
                  if (this.state.Type === "DeclineAlarm") {
                    return (
                      <h2>
                        {t("Monthly Report.Lifeguards declined the Alarm")}
                      </h2>
                    );
                  }
                  if (this.state.Type === "LifeGuardOnSceneForCardiacArrest") {
                    return (
                      <h2>
                        {t(
                          "Monthly Report.Total lifeguards on scene for the cardiac arrest",
                        )}
                      </h2>
                    );
                  }
                  if (this.state.Type === "LifeGuardOnSiteBeforeAmbulance") {
                    return (
                      <h2>
                        {t(
                          "Monthly Report.Total lifeguards on site before ambulance and IVPA",
                        )}
                      </h2>
                    );
                  }
                  if (this.state.Type === "LifeGuardPerformedCPR") {
                    return (
                      <h2>
                        {t("Monthly Report.Total lifeguards performed CPR")}
                      </h2>
                    );
                  }
                  if (this.state.Type === "LifeGuardConnectedDefibrillators") {
                    return (
                      <h2>
                        {t(
                          "Monthly Report.Total lifeguards who have connected defibrillators",
                        )}
                      </h2>
                    );
                  }
                  if (this.state.Type === "LifeGuardUseDefibrillators") {
                    return (
                      <h2>Total lifeguards who have used defibrillators</h2>
                    );
                  }
                })()}
              </div>
              {/* <p style={{fontSize:'large',fontWeight:'bolder'}}>{UserData}</p> */}
            </div>
            <div>{headerUser}</div>
            <div className="">
              <div className="forms add-device setting-panel">
                <div className="widget-shadow">
                  <div className=" panel-body-inputin">
                    <DataTable
                      globalFilter={this.state.globalFilterUser}
                      value={this.props.MonthlyReportDetails.usersList}
                      responsiveLayout="scroll"
                      scrollable
                      scrollHeight="400px"
                      style={{ minWidth: "50rem" }}
                      emptyMessage={t("Feedback Setting.No records found")}
                    >
                      {/* <Column field="FirstName" header={t('First_Responder.Patient Name')} body={this.patientFullname} sortable={true} /> */}
                      <Column
                        field="RegionName"
                        header={t("Monthly Report.Region")}
                        sortable={true}
                        className="wordBreakLine"
                      />

                      <Column
                        field="CreatedDate"
                        header={
                          this.state.Type === "Recruited"
                            ? t("Login.Recruited Date")
                            : t("Monthly Report.Region Register Date")
                        }
                        body={this.formatRegionDate}
                        sortable={true}
                        className="wordBreakLine"
                      />
                      <Column
                        field="FirstName"
                        header={t("Monthly Report.Name")}
                        body={this.patientFullname}
                        sortable={true}
                        className="wordBreakLine"
                      />

                      <Column
                        field="EmailId"
                        header={t("Monthly Report.Email")}
                        sortable={true}
                        className="wordBreakLine"
                      />
                      <Column
                        field="PhoneNumber"
                        header={t("Monthly Report.Phone Number")}
                        sortable={true}
                        className="wordBreakLine"
                      />
                      {this.state.Type != "RegisteredLifeGuard" &&
                      this.state.Type != "Recruited" ? (
                        <Column
                          field="MissionId"
                          header={t("Monthly Report.Mission ID")}
                          sortable={true}
                          className="wordBreakLine"
                        />
                      ) : null}
                      {this.state.Type != "RegisteredLifeGuard" &&
                      this.state.Type != "Recruited" ? (
                        <Column
                          field="AlarmCreatedDate"
                          header={t("Monthly Report.Alarm Created")}
                          body={this.formatAlarmCreatedDate}
                          sortable={true}
                          className="wordBreakLine"
                        />
                      ) : null}
                      {this.state.Type != "RegisteredLifeGuard" &&
                      this.state.Type != "Recruited" ? (
                        <Column
                          field="Status"
                          header={t("Monthly Report.Alarm Status")}
                          sortable={true}
                          className="wordBreakLine"
                        />
                      ) : null}
                      {this.state.Type != "RegisteredLifeGuard" &&
                      this.state.Type != "Recruited" ? (
                        <Column
                          field="StatusUpdatedDate"
                          header={t("Monthly Report.Alarm status Date")}
                          body={this.formatAlarmStatusDate}
                          sortable={true}
                          className="wordBreakLine"
                        />
                      ) : null}
                      {this.state.Type != "RegisteredLifeGuard" &&
                      this.state.Type != "Recruited" ? (
                        <Column
                          field="PosLat"
                          header={t("Monthly Report.Alarm Lat")}
                          sortable={true}
                          className="wordBreakLine"
                        />
                      ) : null}
                      {this.state.Type != "RegisteredLifeGuard" &&
                      this.state.Type != "Recruited" ? (
                        <Column
                          field="PosLon"
                          header={"Alarm Lon"}
                          sortable={true}
                          className="wordBreakLine"
                        />
                      ) : null}

                      {this.state.Type === "LifeGuardPerformedCPR" &&
                      this.state.Type != "RegisteredLifeGuard" &&
                      this.state.Type != "Recruited" ? (
                        <Column
                          field="IsLifeguardPerformedCPR"
                          body={this.formatAlarmStatusDate1}
                          header="Life Guard Permormed CPR"
                          sortable={true}
                          className="wordBreakLine"
                        />
                      ) : null}
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          open={this.state.openModalAlarm}
          onClose={this.closeModalAlarm}
          center
          classNames={{ modal: "UpdateMonthlyUserModal" }}
        >
          <div className="">
            <div className="progressbar-heading grids-heading">
              <h2>{t("Monthly Report.Alarms per day")}</h2>

              {/* <p style={{fontSize:'large',fontWeight:'bolder'}}>{UserData}</p> */}
            </div>
            <div>{headerAlarm}</div>
            <div className="">
              <div className="forms add-device setting-panel">
                <div className="widget-shadow">
                  <div className=" panel-body-inputin">
                    <div className="alarmparentlist">
                      <DataTable
                        value={transformedArray}
                        //loading={this.props.incomingAlarmList.isLoading}
                        paginator={true}
                        rows={10}
                        globalFilter={this.state.globalFilterAlarm}
                        // rowClassName={this.rowClassName}
                        rowExpansionTemplate={this.rowExpansionTemplate}
                        onRowToggle={(e) =>
                          this.setState({ expandedRows: e.data })
                        }
                        expandedRows={this.state.expandedRows}
                        emptyMessage={t("Feedback Setting.No records found")}
                      >
                        <Column
                          style={{
                            fontSize: "large",
                            fontWeight: "bold",
                            width: "3em",
                          }}
                          expander
                        />
                        <Column
                          style={{ fontSize: "large", fontWeight: "bold" }}
                          field="AlarmCreatedDate"
                          header=""
                          className="wordBreakLine"
                        />
                        <Column
                          style={{ fontSize: "large", fontWeight: "bold" }}
                          field="StatusUpdatedDate"
                          header={t("Login.Total Alarms Count")}
                          body={this.formatAlarmCount}
                          sortable={true}
                          className="wordBreakLine"
                        />
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        
<SnackbarProgress
  open={this.state.snackbarOpen}
  progress={this.state.downloadProgress}
/>

      </div>
    );
  }
}
export default withNamespaces()(MonthlyReportComponent);
